module.exports = __webpack_public_path__ + "static/media/02_DSC5646.ac92e610.jpg";